define((require) => {
    "use strict";

    var EasingTypes  = require("shared/ui/experience/widgets/animations/EasingTypes"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/widgets/animations/fade/FadeAnimationPropertiesView.tpl");

    /**
     * The properties view for a fade animation.
     *
     * @class FadeAnimationPropertiesView
     * @constructor
     *
     * @cfg {FadeAnimationModel} model The fade animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#fadeEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/fade/FadeAnimationPropertiesView.js